import { $, $$ } from '@utils';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, EffectFade, A11y } from 'swiper/modules';

function init() {
  if (!$('[data-au-primary-header]')) return;

  $$('[data-au-primary-header]').forEach((slider) => {
    if (slider.querySelectorAll('.swiper-slide').length > 1) buildSlider(slider);
  });
}

function buildSlider(slider) {
  const paginationTitles = slider.querySelector('[data-au-primary-header-pagination]').dataset
    .auPrimaryHeaderPagination;

  new Swiper(slider, {
    modules: [Autoplay, Navigation, Pagination, EffectFade, A11y],
    autoplay: {
      delay: 15000,
      disableOnInteraction: false,
    },
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      prevEl: '[data-au-primary-header-prev]',
      nextEl: '[data-au-primary-header-next]',
    },
    pagination: {
      el: '[data-au-primary-header-pagination]',
      bulletClass: 'au-primary-header__step',
      bulletActiveClass: 'au-primary-header__step--active',
      clickable: true,
      renderBullet: (index, className) => {
        return `<button type="button" class="${className} t-detail" data-au-datalayer="tab" data-au-slider-bullet-index="${index}">
            ${paginationTitles.split(',;')[index]}
            <span class="${className}-progress"></span>
          </button>`;
      },
    },
    slidesPerView: 1,
    a11y: {
      enabled: true,
      slideRole: null,
    },
  });
}

export default { init };
